export const GATEWAY_ENV_OPTIONS = [
  "dev",
  "qa",
  "staging",
  "uat",
  "prod",
  "production",
  "sandbox",
  "test",
] as const;

export type GatewayEnvName = (typeof GATEWAY_ENV_OPTIONS)[number];
